'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.privacyOnEnterSaga = privacyOnEnterSaga;

var _effects = require('redux-saga/effects');

var _countriesServed = require('constants/countries-served');

var _locale = require('redux/modules/locale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(privacyOnEnterSaga);

function privacyOnEnterSaga(store, nextState, replaceState) {
  var countryCode;
  return _regenerator2.default.wrap(function privacyOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!nextState.location.pathname.match(/privacy\/?$/)) {
            _context.next = 6;
            break;
          }

          countryCode = (0, _locale.selectCountry)(store.getState());
          // Only redirect if it's for an active country code

          if (!(countryCode in _countriesServed.COUNTRY_CODE_TO_NAME)) {
            _context.next = 6;
            break;
          }

          _context.next = 5;
          return (0, _effects.call)(replaceState, '/privacy/' + countryCode.toLowerCase());

        case 5:
          return _context.abrupt('return', _context.sent);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}